import React from "react";

import { ImageThreeUpBlock, Image3UpBlock as Value } from "@reactivated";

import { MediaChooserBlock } from "../MediaChooserBlock";
import { RichText } from "../RichText";

import styles from "./index.module.scss";

const Item = ({ media, content }: ImageThreeUpBlock) => {
    return (
        <div className={styles.item}>
            {media && media.length > 0 ? (
                <MediaChooserBlock
                    wrapperAttrs={{ className: styles.media }}
                    value={media}
                    type="background"
                />
            ) : null}
            {content && (
                <RichText value={content} className={styles.richText} />
            )}
        </div>
    );
};

interface Props {
    value: Value;
    id?: string;
}

export const Image3UpBlock = ({
    value: { header_content, items, theme },
    id: propId,
}: Props) => {
    if (!items || items.length === 0) return <></>;

    const id = propId || "three-up-block";

    return (
        <section className={styles[theme ?? "match"]}>
            <div className={styles.grid}>
                <div className={styles.header}>
                    {header_content && <RichText value={header_content} />}
                </div>
            </div>
            <div className={styles.grid}>
                {items.map((item, index) => (
                    <Item {...item} key={`${id}-${index}`} />
                ))}
            </div>
        </section>
    );
};
